import { z } from "zod";

import { readPref, writePref } from "./prefs";

export const firstAdSearch = z.object({
  template: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).max(64).optional().catch(undefined),
  product: z.string().max(1500).optional().catch(undefined),
  manual: z.preprocess((value) => value === "true" ? true : value === "false" ? false : value, z.boolean().optional()).catch(undefined),
});
export type FirstAdSearch = z.infer<typeof firstAdSearch>;

/** Product links carry no account credentials or fragment through OAuth or browser history. */
export function productLink(value: string): string | null {
  try {
    const url = new URL(value.trim());
    if (!["http:", "https:"].includes(url.protocol) || url.username || url.password) return null;
    url.hash = "";
    return url.href.length <= 1500 && new URLSearchParams({ product: url.href }).toString().length <= 1850 ? url.href : null;
  } catch {
    return null;
  }
}

export function firstAdChoice(search: FirstAdSearch) {
  const saved = readPref("firstAdChoice");
  // An explicit URL choice is authoritative, including the absence of a link in manual mode.
  const raw = search.template === undefined ? saved : search;
  if (!raw?.template) return null;
  const manual = raw.manual === true;
  const product = manual ? "" : productLink(raw.product ?? "");
  return product === null ? null : { template: raw.template, product, manual };
}

export function keepFirstAdChoice(choice: NonNullable<ReturnType<typeof firstAdChoice>>): void {
  writePref("firstAdChoice", choice);
}

export function firstAdReturn(choice: NonNullable<ReturnType<typeof firstAdChoice>>): string {
  const query = new URLSearchParams({ template: choice.template });
  if (choice.manual) query.set("manual", "true");
  else query.set("product", choice.product);
  return `/start/free/create?${query}`;
}
